/**
 * Плагин: двойной клик по подписи edge — открыть редактор подписи связи.
 */
export default {
	init(modeler, context) {
		const {graph} = context;

		const onEdgeDblclick = ({cell, view, e}) => {
			const target = e?.target;
			const isLabelClick =
				target &&
				view?.container &&
				view.container.contains(target) &&
				(target.tagName === 'TEXT' ||
					target.closest?.('text') ||
					target.closest?.('[class*="label"]'));
			if (!isLabelClick) return;
			modeler._openConnectionLabelEditor(cell);
		};

		graph.on('edge:dblclick', onEdgeDblclick);

		return () => graph.off('edge:dblclick', onEdgeDblclick);
	},
};
